import { render } from "./ChatPlatformSelection.vue?vue&type=template&id=0d21ec28"
import script from "./ChatPlatformSelection.vue?vue&type=script&lang=js"
export * from "./ChatPlatformSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__